/* global _:true*/

(function () {
  'use strict';

  angular.module('eDocumentsApp').controller('DocumentDetailController', DocumentDetailController);

  DocumentDetailController.$inject = [
    'Principal',
    '$ngConfirm',
    '$scope',
    '$state',
    '$translate',
    'Document',
    'previousState',
    'entity',
    'CommunicationWorkflowStep',
    'Communication',
    'DataUtils',
    'Notification',
    'DocumentDownloadPdf',
    'CommunicationEntity',
    'CurrencyUtils',
    'translationHandler',
    '$timeout',
  ];

  function DocumentDetailController(
    Principal,
    $ngConfirm,
    $scope,
    $state,
    $translate,
    Document,
    previousState,
    entity,
    CommunicationWorkflowStep,
    Communication,
    DataUtils,
    Notification,
    DocumentDownloadPdf,
    CommunicationEntity,
    CurrencyUtils,
    translationHandler,
    $timeout
  ) {
    var vm = this;
    vm.document = entity;

    // The tab says which document this is, not merely that it is a document.
    if (vm.document && vm.document.documentNumber) {
      translationHandler.setSubject(vm.document.documentNumber, 'eDocumentsApp.document.home.title');
    }
    vm.previousState = previousState.name;
    vm.maximumOrder = undefined;
    vm.download = download;
    vm.canAdminRedoStep = canAdminRedoStep;
    vm.canRedoStep = canRedoStep;
    vm.redoStep = redoStep;
    vm.canAdminDoStep = canAdminDoStep;
    vm.canDoStep = canDoStep;
    vm.doStep = doStep;
    vm.downloaded = downloaded;
    vm.getCurrency = getCurrency;
    vm.getViewableFilename = DataUtils.getViewableFilename;
    vm.formatFileSize = DataUtils.formatFileSize;
    vm.getFileIconClass = DataUtils.getFileIconClass;
    vm.goBack = goBack;
    // EDOCS-664: e-mailing the document to any address, and its sharing history
    vm.sharing = null;
    vm.share = { open: false, email: '', sending: false, sentTo: null, errorKey: null, reasonShown: false };
    vm.toggleSharePanel = toggleSharePanel;
    vm.shareByEmail = shareByEmail;
    vm.shareEmailError = shareEmailError;
    vm.shareResultClass = shareResultClass;
    vm.shareResultKey = shareResultKey;
    vm.shareResultHintKey = shareResultHintKey;
    vm.shareChannelKey = shareChannelKey;
    vm.shareRequester = shareRequester;
    // the steps in ERROR, for the summary line under the document number, and the jump to one of them
    vm.errorSteps = [];
    vm.goToStep = goToStep;
    vm.hasSerials = false;

    activate();

    function loadSharing() {
      Document.sharing({ id: vm.document.id }).$promise.then(
        function (sharing) {
          vm.sharing = sharing;
        },
        function () {
          vm.sharing = null;
        }
      );
    }

    function focusById(id) {
      $timeout(function () {
        var target = document.getElementById(id);
        if (target) {
          target.focus();
        }
      });
    }

    function toggleSharePanel() {
      // aria-disabled does not stop a click: an account that cannot share gets the reason, on a line under the buttons
      if (!vm.sharing || !vm.sharing.canShare) {
        vm.share.reasonShown = true;
        return;
      }
      vm.share.open = !vm.share.open;
      vm.share.sentTo = null;
      vm.share.errorKey = null;
      // opening puts the caret in the address field; closing gives focus back to the button that opened the panel
      $timeout(function () {
        var target = angular.element(vm.share.open ? '#share-email' : '#share-toggle');
        if (target.length) {
          target.focus();
        }
      });
    }

    /**
     * The address field shows its error after a send was attempted, or once something was typed and the field left;
     * never on an untouched empty field, and never because the window lost focus.
     */
    function shareEmailError(form) {
      if (!form || !form.email || !form.email.$invalid) {
        return false;
      }
      return form.$submitted || (form.email.$touched && form.email.$dirty);
    }

    function shareByEmail(form) {
      if (vm.share.sending) {
        return;
      }
      // Enviar stays enabled: an invalid address shows the message and gives the caret back to the field
      if (form && form.$invalid) {
        focusById('share-email');
        return;
      }
      vm.share.sending = true;
      vm.share.errorKey = null;
      vm.share.sentTo = null;
      var email = vm.share.email.trim();
      Document.shareByEmail({ id: vm.document.id }, { email: email }).$promise.then(
        function () {
          vm.share.sending = false;
          vm.share.sentTo = email;
          vm.share.email = '';
          if (form) {
            form.$setPristine();
            form.$setUntouched();
          }
          // the fieldset was disabled while sending, which drops focus: give it back to the field for the next address
          focusById('share-email');
          loadSharing();
        },
        function (error) {
          vm.share.sending = false;
          vm.share.errorKey = error && error.data && error.data.message ? error.data.message : 'error.shareSendFailed';
          focusById('share-email');
        }
      );
    }

    /** The badge of a history line: sent, failed, or a link that predates the record (no outcome known). */
    function shareResultClass(entry) {
      if (isLinkHandedOver(entry)) {
        return 'badge-link-handed-over';
      }
      if (entry.result === 'SENT') {
        return 'badge-success';
      }
      if (entry.result === 'FAILED') {
        return 'badge-danger';
      }
      return 'badge-light';
    }

    /** A link handed to the issuer's application was not e-mailed by us: "Sent" would say more than is known. */
    function isLinkHandedOver(entry) {
      return entry.delivery === 'LINK' && entry.result !== 'FAILED';
    }

    function shareResultKey(entry) {
      if (isLinkHandedOver(entry)) {
        return 'eDocumentsApp.document.share.result.LINK_HANDED_OVER';
      }
      return 'eDocumentsApp.document.share.result.' + (entry.result || 'UNKNOWN');
    }

    /** The hover hint of a result badge, as a translation key; null when the badge says it all. */
    function shareResultHintKey(entry) {
      if (isLinkHandedOver(entry)) {
        return 'eDocumentsApp.document.share.history.deliveredByApplication';
      }
      return entry.result ? null : 'eDocumentsApp.document.share.result.UNKNOWN_hint';
    }

    /** API sends say how they went out: a link for the application, or an e-mail eDocuments sent. */
    function shareChannelKey(entry) {
      if (entry.channel === 'API') {
        return 'eDocumentsApp.document.share.channel.' + (entry.delivery === 'LINK' ? 'API_LINK' : 'API_EMAIL');
      }
      return 'eDocumentsApp.document.share.channel.' + entry.channel;
    }

    /** Who asked: the login or API process; for a new link asked by the recipient, the recipient; none for the workflow. */
    function shareRequester(entry) {
      if (entry.requestedBy) {
        return entry.requestedBy;
      }
      if (entry.channel === 'RESEND') {
        return entry.recipient || entry.recipientReference || null;
      }
      return null;
    }

    function goToStep(step) {
      if (step) {
        focusById('step-' + step.order);
      }
    }

    function downloaded(id) {
      return vm.document.documentDownloads.filter(function (documentDownload) {
        return documentDownload.fileId === id;
      }).length;
    }

    function clear() {
      $state.go('document');
    }

    function fillObject(object, result) {
      object.companyName = result.name;
    }

    function fillInvoice(isSELFBILLED) {
      if (isSELFBILLED) {
        CommunicationEntity.get({ id: vm.document.originId }, function (result) {
          fillObject(vm.invoice.receiver, result);
          fillObject(vm.invoice.sender, result);
        });
      } else {
        if (!vm.invoice.sender.companyName) {
          CommunicationEntity.get({ id: vm.document.originId }, function (result) {
            fillObject(vm.invoice.sender, result);
          });
        }
        if (!vm.invoice.receiver.companyName) {
          CommunicationEntity.get({ id: vm.document.destinationId }, function (result) {
            fillObject(vm.invoice.receiver, result);
          });
        }
      }
    }

    function activate() {
      if (vm.document === null) {
        Notification.error({ message: 'Documento não encontrado!' }); // TODO translate
        clear();
      } else {
        vm.approvalInfo = {
          approvedBy: vm.document.approvedBy,
          approvedDate: vm.document.approvedDate,
        };

        if (vm.document.documentType === 'ORDER') {
          Document.getOrder({ id: vm.document.id }).$promise.then(function (result) {
            vm.order = result;
            CommunicationEntity.findByGln({ gln: vm.order.header.supplier.gln }, function (result) {
              vm.orderSupplier = result;
            });
            CommunicationEntity.findByGln({ gln: vm.order.header.buyer.gln }, function (result) {
              vm.orderReceiver = result;
            });
          });
        } else if (vm.document.documentType === 'DESPATCHADVICE') {
          // a despatch advice (EDOCS-662) has its own typed content: supplier, buyer, lines and pallets
          Document.getDespatchAdvice({ id: vm.document.id }).$promise.then(function (result) {
            vm.despatchAdvice = buildDespatchAdviceView(result);
          });
        } else {
          Document.getInvoice({ id: vm.document.id }).$promise.then(function (result) {
            vm.invoice = result;
            // the serial number column only earns its width when some line has one
            vm.hasSerials = (vm.invoice.lines || []).some(function (line) {
              return line.serialNumber && line.serialNumber.serialNumber;
            });
            if (
              (vm.document.documentType === 'SELFBILLED' && !vm.invoice.receiver.companyName) ||
              (vm.document.documentType !== 'SELFBILLED' && (!vm.invoice.sender.companyName || !vm.invoice.receiver.companyName))
            ) {
              fillInvoice(vm.document.documentType === 'SELFBILLED');
            }
          });
        }

        Principal.identity().then(function (account) {
          vm.account = account;
          // EDOCS-664: sharing belongs to the issuing entity; asking only when it could answer keeps a recipient's
          // screen from logging a refused request on every document it opens
          if (Principal.hasAnyAuthority(['ROLE_SUPERADMIN']) || Principal.isUserEntityMember(vm.document.originId)) {
            loadSharing();
          }
          for (var i = 0; i < vm.account.userEntities.length; i++) {
            if (
              (vm.account.userEntities[i].entityId === vm.document.originId || vm.account.userEntities[i].entityId === vm.document.destinationId) &&
              vm.account.userEntities[i].manager
            ) {
              vm.manager = true;
              break;
            }
          }
        });
        Document.addView(vm.document.id);
        vm.currentWorkflow = {};
        CommunicationWorkflowStep.findByDefinition({ id: vm.document.communicationDefinitionId }).$promise.then(function (steps) {
          vm.workflow = steps;
          for (var i = 0; i < vm.workflow.length; i++) {
            vm.currentWorkflow[vm.workflow[i].id] = {
              order: vm.workflow[i].order,
              id: vm.workflow[i].id,
              executionTime: vm.workflow[i].originParameters.filter(function (originParameter) {
                return originParameter.communicationParameterType === 'EXECUTION_TIME';
              })[0],
              description: vm.workflow[i].description,
              name: vm.workflow[i].communicationActionDefinitionName,
              executionType: vm.workflow[i].executionType,
              communicationType: vm.workflow[i].communicationType,
            };
            vm.maximumOrder = angular.isUndefined(vm.maximumOrder) || vm.workflow[i].order > vm.maximumOrder ? vm.workflow[i].order : vm.maximumOrder;
          }
          Communication.findByDocument({ id: vm.document.id }).$promise.then(function (communications) {
            vm.communications = communications;
            for (var j = 0; j < vm.communications.length; j++) {
              var workflow = vm.currentWorkflow[vm.communications[j].communicationWorkflowStepId];
              workflow.status = vm.communications[j].status;
              workflow.previousStatus = vm.communications[j - 1] ? vm.communications[j - 1].status : undefined;
              workflow.message = vm.communications[j].message;
              workflow.code = vm.communications[j].code;
              workflow.time = vm.communications[j].communicationTime;
              vm.currentWorkflow[vm.communications[j].communicationWorkflowStepId] = workflow;
            }
            var array = [];
            for (var objectKey in vm.currentWorkflow) {
              if (vm.currentWorkflow.hasOwnProperty(objectKey) && angular.isObject(vm.currentWorkflow[objectKey]) && objectKey.charAt(0) !== '$') {
                array.push(vm.currentWorkflow[objectKey]);
              }
            }
            array.sort(function (a, b) {
              a = a.order ? a.order : '0';
              b = b.order ? b.order : '0';
              return parseInt(a) - parseInt(b);
            });
            vm.currentWorkflow = array;
            vm.errorSteps = array.filter(function (step) {
              return step.status === 'ERROR';
            });
          });
        });
      }
    }

    // ---- despatch advice preview (EDOCS-662) ----
    // Labels for the identifier, reference and quantity types papiNet and RF006 use. A type not listed here is
    // shown as the sender wrote it, so nothing the supplier sent is hidden.
    var DA_KEY = 'eDocumentsApp.document.detail.despatchAdvice.';
    var DA_PARTY_IDS = {
      VATIdentificationNumber: 'vat',
      GlobalLocationNumber: 'gln',
      AssignedBySeller: 'assignedBySeller',
      AssignedByBuyer: 'assignedByBuyer',
    };
    // product identifiers are labelled by type and by who assigned them, e.g. "Referência (fornecedor)"
    var DA_PRODUCT_TYPES = ['PartNumber', 'GradeCode', 'GradeName', 'BrandName', 'GTIN'];
    var DA_AGENCIES = ['Supplier', 'Buyer'];
    var DA_REFERENCES = ['MillOrderNumber', 'MillOrderLineItemNumber', 'SupplierCallOffNumber', 'OriginalDeliveryNumber', 'BookingNumber'];
    var DA_QUANTITIES = ['GrossWeight', 'NetWeight', 'TareWeight', 'NominalWeight', 'Count'];
    var DA_PACKAGES = ['Pallet', 'Reel', 'Box'];

    function daLabel(known, type) {
      return known ? { key: DA_KEY + known } : { text: type };
    }

    function daProductLabel(identifier) {
      var label = daLabel(DA_PRODUCT_TYPES.indexOf(identifier.type) >= 0 ? 'productType.' + identifier.type : null, identifier.type);
      if (identifier.agency) {
        label.agency = DA_AGENCIES.indexOf(identifier.agency) >= 0 ? { key: DA_KEY + 'agency.' + identifier.agency } : { text: identifier.agency };
      }
      return label;
    }

    function daParty(party) {
      if (!party) {
        return null;
      }
      var address = party.address || {};
      return {
        name: party.name,
        lines: [address.name2, address.street, [address.postalCode, address.city].filter(Boolean).join(' '), address.countryCode].filter(Boolean),
        identifiers: (party.identifiers || []).map(function (identifier) {
          return { label: daLabel(DA_PARTY_IDS[identifier.type], identifier.type), value: identifier.value };
        }),
      };
    }

    function daReference(reference) {
      var known = DA_REFERENCES.indexOf(reference.type) >= 0 ? 'reference.' + reference.type : null;
      return { label: daLabel(known, reference.type), value: reference.value };
    }

    function daQuantity(quantity) {
      var known = DA_QUANTITIES.indexOf(quantity.quantityType) >= 0 ? 'quantityType.' + quantity.quantityType : null;
      return { label: daLabel(known, quantity.quantityType), value: quantity.value, uom: quantity.uom, informational: quantity.informational };
    }

    function daIdentifier(identifiers, codeType) {
      var found = (identifiers || []).filter(function (identifier) {
        return identifier.codeType === codeType;
      })[0];
      return found ? found.value : null;
    }

    // Totals are kept per unit (kilograms never added to sheets) and count the pallets that carried the measure,
    // so a total that only some pallets contributed to says so instead of passing for the whole shipment.
    function daAdd(totals, quantity) {
      var value = quantity ? parseFloat(quantity.value) : NaN;
      if (isNaN(value)) {
        return;
      }
      var uom = quantity.uom || '';
      var total = totals[uom] || { value: 0, pallets: 0 };
      total.value = Number((total.value + value).toFixed(6));
      total.pallets++;
      totals[uom] = total;
    }

    function daTotalsList(totals, palletCount) {
      return Object.keys(totals).map(function (uom) {
        return { value: totals[uom].value, uom: uom, partial: totals[uom].pallets < palletCount ? { n: totals[uom].pallets, total: palletCount } : null };
      });
    }

    function buildDespatchAdviceView(advice) {
      var header = advice.header || {};
      var gross = {};
      var net = {};
      var items = {};
      var palletCount = 0;
      var lines = (advice.lines || []).map(function (line) {
        var pallets = (line.packages || []).map(function (pack) {
          palletCount++;
          var weights = (pack.quantities || []).filter(function (quantity) {
            return quantity.quantityType !== 'Count';
          });
          var byType = function (type) {
            // a Quantity beats an InformationalQuantity of the same type, as in the RF006 mapping
            var matches = weights.filter(function (quantity) {
              return quantity.quantityType === type;
            });
            return (
              matches.filter(function (quantity) {
                return !quantity.informational;
              })[0] || matches[0]
            );
          };
          daAdd(gross, byType('GrossWeight'));
          daAdd(net, byType('NetWeight'));
          daAdd(items, pack.itemCount);
          return {
            id: pack.id,
            type: daLabel(DA_PACKAGES.indexOf(pack.packageType) >= 0 ? 'packageType.' + pack.packageType : null, pack.packageType),
            sscc: daIdentifier(pack.identifiers, 'SerialisedShippingContainerCode'),
            uic14: daIdentifier(pack.identifiers, 'UIC14'),
            itemCount: pack.itemCount,
            quantities: (pack.quantities || []).map(daQuantity),
          };
        });
        return {
          lineNumber: line.lineNumber,
          purchaseOrderNumber: line.purchaseOrderNumber,
          purchaseOrderLineItemNumber: line.purchaseOrderLineItemNumber,
          description: line.description,
          products: (line.productIdentifiers || []).map(function (identifier) {
            return { label: daProductLabel(identifier), value: identifier.value };
          }),
          references: (line.references || []).map(daReference),
          quantities: (line.quantities || []).map(daQuantity),
          itemInstances: line.itemInstances || [],
          pallets: pallets,
        };
      });
      return {
        number: header.documentNumber,
        date: header.documentDate,
        time: header.documentTime,
        statusType: header.statusType,
        despatchDate: header.despatchDate,
        estimatedDeliveryDate: header.estimatedDeliveryDate,
        supplier: daParty(header.supplierParty),
        buyer: daParty(header.buyerParty),
        shipTo: daParty(header.shipToParty),
        shipFrom: daParty(header.shipFromParty),
        carrier: daParty(header.carrierParty),
        transport: header.transport,
        references: (header.references || []).map(daReference),
        lines: lines,
        totals: {
          lines: lines.length,
          declaredLines: header.numberOfLines,
          pallets: palletCount,
          gross: daTotalsList(gross, palletCount),
          net: daTotalsList(net, palletCount),
          items: daTotalsList(items, palletCount),
        },
      };
    }

    function getCurrency() {
      if (vm.invoice && vm.invoice.header) {
        return CurrencyUtils.getCurrency(vm.invoice.header.currencyCode);
      }
      if (vm.order && vm.order.header) {
        return CurrencyUtils.getCurrency(vm.order.header.currencyCode);
      }
      return '';
    }

    function download($event, fileId, fileType) {
      DocumentDownloadPdf.download($event, vm.document, fileId, fileType);
    }

    function canAdminRedoStep(step) {
      return (
        !canRedoStep(step) && // if we can already redo step as regular user we should not show the action again
        step.status !== 'SCHEDULED' &&
        step.order !== 1
      );
    }

    function canRedoStep(step) {
      if (
        step.order === vm.maximumOrder &&
        (step.communicationType === 'EMAIL_OUT' ||
          step.communicationType === 'UNEDIFACT_EMAIL_OUT' ||
          (step.communicationType === 'MOLONI_ORDER_INTEGRATION' && step.code === 'ERR0059'))
      ) {
        // if is a mail sending step and the last one
        return true;
      }
      if (vm.manager === true) {
        return (
          step.order !== 1 && ((vm.document.status === 'ERROR' && step.status === 'ERROR') || (vm.document.status === 'WAITING' && step.status === 'WAITING'))
        );
      }
      return false;
    }

    function redoStep(step) {
      $ngConfirm({
        title: $translate.instant('eDocumentsApp.document.detail.resend.title'),
        columnClass: 'medium',
        type: 'orange',
        animation: 'right',
        animationBounce: 1,
        closeAnimation: 'scale',
        content: $translate.instant('eDocumentsApp.document.detail.resend.message'),
        scope: $scope,
        buttons: {
          confirm: {
            text: $translate.instant('entity.action.confirm'),
            btnClass: 'btn-warning',
            keys: ['enter'],
            action: function () {
              Document.redoFromStep({
                docId: vm.document.id,
                stepId: step.id,
              }).$promise.then(function () {
                $state.reload();
              });
            },
          },
          close: {
            text: $translate.instant('entity.action.cancel'),
            btnClass: 'btn-default',
            keys: ['esc'],
            action: function () {
              // do nothing
            },
          },
        },
      });
    }

    function canAdminDoStep(step) {
      return step.executionType === 'MANUAL' && step.status === 'WAITING' && (!step.previousStatus || step.previousStatus === 'SUCCESS');
    }

    function canDoStep(step) {
      return (
        vm.document.status === 'WAITING' &&
        vm.manager === true &&
        step.executionType === 'MANUAL' &&
        step.status === 'WAITING' &&
        (!step.previousStatus || step.previousStatus === 'SUCCESS')
      );
    }

    function doStep(step) {
      $ngConfirm({
        title: $translate.instant('eDocumentsApp.document.detail.execute.title'),
        columnClass: 'medium',
        type: 'blue',
        animation: 'right',
        animationBounce: 1,
        closeAnimation: 'scale',
        content: $translate.instant('eDocumentsApp.document.detail.execute.message'),
        scope: $scope,
        buttons: {
          confirm: {
            text: $translate.instant('entity.action.confirm'),
            btnClass: 'btn-blue',
            keys: ['enter'],
            action: function () {
              Document.doFromStep({
                docId: vm.document.id,
                stepId: step.id,
              }).$promise.then(function () {
                $state.reload();
              });
            },
          },
          close: {
            text: $translate.instant('entity.action.cancel'),
            btnClass: 'btn-default',
            keys: ['esc'],
            action: function () {
              // do nothing
            },
          },
        },
      });
    }

    function goBack() {
      window.history.back();
    }
  }
})();
